import LoadingIndicator from "../utils/LoadingIndicator";
import { showToastMessage } from "./toastMsg";
import React from "react";

export const Authentication = () => {
  showToastMessage("error", `Session Expired, logging out`);
  setTimeout(TimeOut, 3000);
  return (
    <>
      <LoadingIndicator />
    </>
  );
};

export const TimeOut = () => {
  sessionStorage.clear();
  // window.location.reload();
};
